import { Stack, Typography } from '@mui/material';
import { random } from 'lodash';
import { useSnackbar } from 'notistack';
import { CustomWaterLoading } from 'src/components';
import { HandleDeleteAlarmEventTypes } from 'src/features/alarms';
import { MobileAlarmCard } from 'src/features/alarms/components/mobile/mobile-alarm-card';
import { AlarmsService } from 'src/services/alarms';
import { AlarmDataV3 } from 'src/types/alarms';

type Props = {
  alarms: AlarmDataV3[] | [];
  isLoaded: boolean;
  onAcknowledged: (response: AlarmDataV3) => void;
  setAlarmData: React.Dispatch<React.SetStateAction<AlarmDataV3[]>>;
};

export const AlarmsList = ({ alarms, isLoaded, onAcknowledged, setAlarmData }: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  if (!isLoaded) {
    return <CustomWaterLoading />;
  }
  if (alarms.length === 0) {
    return (
      <Stack flex="1" alignItems="center" justifyContent="center" padding="20px">
        <Typography variant="body2">No alarms found.</Typography>
      </Stack>
    );
  }

  const handleDeleteAlarmEvent = async ({
    customerId,
    siteId,
    alarmId,
  }: HandleDeleteAlarmEventTypes) => {
    if (!customerId || !siteId || !alarmId) return;
    try {
      await AlarmsService.deleteAlarmEventV3({
        customerId: customerId,
        siteId: siteId,
        alarmId: alarmId,
      });
      setAlarmData((prevState) => {
        if (!prevState) return [];

        const newValue = prevState.filter((item) => item.id !== alarmId);
        return newValue;
      });

      enqueueSnackbar('Alarm event deleted successfully', { variant: 'success' });
    } catch (error) {
      const message = error?.response?.data?.message || 'Failed to delete alarm event';
      enqueueSnackbar(message, { variant: 'error' });
      console.error(error);
    }
  };

  return (
    <Stack flex="1" overflow="auto" paddingBottom="60px">
      {alarms?.map((alarm, index) => (
        <MobileAlarmCard
          logs
          index={index}
          itemRefs={{ current: [] }}
          onAcknowledged={onAcknowledged}
          alarmData={alarm}
          key={alarm.id ?? random().toString()}
          handleDeleteAlarmEvent={handleDeleteAlarmEvent}
          setAlarmData={undefined}
        />
      ))}
    </Stack>
  );
};
